export enum StatusModulo {
  attivato = 'ATTIVATO',
  inValutazione = 'IN_VALUTAZIONE',
  completato = 'COMPLETATO',
  daAttivare = 'DA_ATTIVARE'
}
